"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _main_1 = require("../_main");
_main_1.txGs1Base.academyEventPanels = {
    // The current viewport width
    viewportWidth: $(window).width(),
    // See LESS file variables.less L267
    viewportBreakPointForTabs: 768,
    // Number of current visible tabs
    numVisibleTabs: 0,
    // Number of tabs created by editors on page
    numAvailableTabs: 0,
    // Just an iterator
    tabIterator: 0,
    // The current active tab (on load: 1)
    currentActiveTab: 1,
    // Number of tabs visible (will be overridden by viewport size
    numVisibleTabsMax: 1,
    /**
     * Initialize tab layout for academy event schendule
     */
    initialize: function () {
        'use strict';
        // Pfeile rechts links ausblenden wenn nicht geblättert werden kann
        // Start width first
        var tabId = 1;
        // Loop through all tabs and prepare initial view
        $.each($('.nav-element'), function () {
            // Add required tab id as data attributes
            $(this).attr('data-tab-id', tabId);
            // Set the first tab active on page load
            if (tabId === 1) {
                $(this).addClass('active');
            }
            else if (tabId > 1) {
                // Hide any gridelement not related with the current active tab
                var relatedGridelementUid = $(this).data('related-gridelement-uid');
                $('#c' + relatedGridelementUid).addClass('hidden');
            }
            tabId++;
        });
        // Set initial value for viewport width
        _main_1.txGs1Base.academyEventPanels.viewportWidth = $(window).width();
        // Trigger DOM manipulation
        _main_1.txGs1Base.academyEventPanels.rearrangeDom();
        // Initialize the first view based on current viewport
        this.redrawForViewport();
        // Add listeners
        this.addResizeListener();
        this.addNavigationListener();
        this.addContentElementListener();
        // Manipulate event schedule borders
        if ($('.academy-event-page').length > 0) {
            $('.event-schedule-item-container').each(function () {
                var $next = $(this).next();
                if ($next.hasClass('event-schedule-item-container') === false) {
                    $(this).addClass('no-border');
                }
            });
        }
    },
    /**
     * A listener for window resize events to set the proper amount
     * of visible tabs on desktop also
     */
    addResizeListener: function () {
        // Add listener for resize events
        $(window).on('resize', function () {
            // Only trigger redraw if width changes
            if (_main_1.txGs1Base.academyEventPanels.viewportWidth !== $(window).width()) {
                _main_1.txGs1Base.academyEventPanels.viewportWidth = $(window).width();
                _main_1.txGs1Base.academyEventPanels.redrawForViewport();
            }
        });
    },
    /**
     * Navigation (left/right) and tab bar event listeners
     */
    addNavigationListener: function () {
        $('.nav-element').on('click', function () {
            _main_1.txGs1Base.academyEventPanels.selectTab(this);
        });
        $('.nav-left').on('click', function (item) {
            _main_1.txGs1Base.academyEventPanels.navigateLeft(item);
        });
        $('.nav-right').on('click', function (item) {
            _main_1.txGs1Base.academyEventPanels.navigateRight(item);
        });
    },
    /**
     * Various content manipulation listeners
     */
    addContentElementListener: function () {
        // Bind to all available toggle elements
        $('.item-toggle').on('click', function () {
            $(this).toggleClass('expanded');
            $('#' + $(this).data('itemId')).slideToggle('slow');
        });
    },
    /**
     * Redraw the tab bar after a view port change has happened
     */
    redrawForViewport: function () {
        if (_main_1.txGs1Base.academyEventPanels.viewportWidth <= _main_1.txGs1Base.academyEventPanels.viewportBreakPointForTabs) {
            _main_1.txGs1Base.academyEventPanels.numVisibleTabsMax = 1;
        }
        else {
            _main_1.txGs1Base.academyEventPanels.numVisibleTabsMax = 3;
        }
        _main_1.txGs1Base.academyEventPanels.initializeTabs();
    },
    /**
     * Rearrange the DOM moving content around from top to bottom
     * for elements of the right top column inside the first Grid-4
     */
    rearrangeDom: function () {
        // Only on academy pages w/ viewport < mobile breakpoint
        if ($('body').hasClass('academy-event-page') && $(window).width() <= 768) {
            // Get the first right column container in #main inside a Grid-4
            var rightColumnContentElement = $('#main .grid-4 .grid-col-right').first();
            // Wrap the content as a new main container
            var rightColumnContent = '<div class="content margin-default grid-container container grid-4">' + rightColumnContentElement.html() + '</div>';
            // Append it as last element in #main
            $('#main').append(rightColumnContent);
            // Delete the right column container
            rightColumnContentElement.remove();
        }
    },
    /**
     * Initialize tabs for the current screen size
     */
    initializeTabs: function () {
        // Reset any previous counter
        _main_1.txGs1Base.academyEventPanels.numAvailableTabs = 0;
        _main_1.txGs1Base.academyEventPanels.numVisibleTab = 0;
        _main_1.txGs1Base.academyEventPanels.tabIterator = 0;
        // Iterate throughout all tabs
        $.each($('.nav-element'), function (index, item) {
            if (_main_1.txGs1Base.academyEventPanels.tabIterator >= _main_1.txGs1Base.academyEventPanels.numVisibleTabsMax) {
                if (!$(item).hasClass('hidden')) {
                    $(item).addClass('hidden');
                }
            }
            else {
                $(item).removeClass('hidden');
                _main_1.txGs1Base.academyEventPanels.numVisibleTabs++;
            }
            _main_1.txGs1Base.academyEventPanels.tabIterator++;
            _main_1.txGs1Base.academyEventPanels.numAvailableTabs++;
        });
    },
    /**
     * Trigger all actions if a tab has been selected
     * @param tab
     */
    selectTab: function (tab) {
        var clickedTabId = $(tab).data('tabId');
        _main_1.txGs1Base.academyEventPanels.currentActiveTab = clickedTabId;
        $(tab).addClass('active');
        // Display the content box related to selected tab
        var relatedGridelementUid = $(tab).data('related-gridelement-uid');
        $('#c' + relatedGridelementUid).removeClass('hidden').addClass('active');
        // Iterate through the rest of the tabs and hide any related content element
        $.each($('.nav-element'), function (index, item) {
            if ($(item).data('tabId') !== clickedTabId) {
                var relatedGridelementUid = $(item).data('related-gridelement-uid');
                $('#c' + relatedGridelementUid).removeClass('active').addClass('hidden');
                $(item).removeClass('active');
            }
        });
    },
    /**
     * »Move tab list to the left«-event
     * @param item
     */
    navigateLeft: function (item) {
        if (_main_1.txGs1Base.academyEventPanels.numVisibleTabsMax === 1) {
            if (_main_1.txGs1Base.academyEventPanels.currentActiveTab - 1 >= 1) {
                _main_1.txGs1Base.academyEventPanels.currentActiveTab = _main_1.txGs1Base.academyEventPanels.currentActiveTab - 1;
            }
            $.each($('.nav-element'), function (index, item) {
                if ($(item).data('tabId') !== _main_1.txGs1Base.academyEventPanels.currentActiveTab) {
                    $(item).removeClass('active').addClass('hidden');
                }
                else {
                    $(item).removeClass('active').removeClass('hidden');
                }
            });
            $('.nav-element[data-tab-id=\'' + _main_1.txGs1Base.academyEventPanels.currentActiveTab + '\']').removeClass('hidden').addClass('active');
        }
        else {
            if (_main_1.txGs1Base.academyEventPanels.currentActiveTab >= 2) {
                _main_1.txGs1Base.academyEventPanels.currentActiveTab = _main_1.txGs1Base.academyEventPanels.currentActiveTab - 1;
                $.each($('.nav-element'), function (index, item) {
                    if ($(item).data('tabId') !== _main_1.txGs1Base.academyEventPanels.currentActiveTab && $(item).data('tabId') !== (_main_1.txGs1Base.academyEventPanels.currentActiveTab - 1) && $(item).data('tabId') !== (_main_1.txGs1Base.academyEventPanels.currentActiveTab + 1)) {
                        if (_main_1.txGs1Base.academyEventPanels.currentActiveTab === 1 && $(item).data('tabId') === (_main_1.txGs1Base.academyEventPanels.numVisibleTabsMax)) {
                            $(item).removeClass('active');
                        }
                        else {
                            $(item).removeClass('active').addClass('hidden');
                        }
                    }
                    else {
                        $(item).removeClass('active').removeClass('hidden');
                    }
                });
                $('.nav-element[data-tab-id=\'' + _main_1.txGs1Base.academyEventPanels.currentActiveTab + '\']').removeClass('hidden').addClass('active');
            }
        }
        // Finally tell the UI what tab should be marked a s selected
        this.selectTab($('.nav-element[data-tab-id=\'' + _main_1.txGs1Base.academyEventPanels.currentActiveTab + '\']'));
    },
    /**
     * »Move tab list to the right«-event
     * @param item
     */
    navigateRight: function (item) {
        if (_main_1.txGs1Base.academyEventPanels.numVisibleTabsMax === 1) {
            if (_main_1.txGs1Base.academyEventPanels.currentActiveTab + 1 <= _main_1.txGs1Base.academyEventPanels.numAvailableTabs) {
                _main_1.txGs1Base.academyEventPanels.currentActiveTab = _main_1.txGs1Base.academyEventPanels.currentActiveTab + 1;
            }
            $.each($('.nav-element'), function (index, item) {
                if ($(item).data('tabId') !== _main_1.txGs1Base.academyEventPanels.currentActiveTab) {
                    $(item).removeClass('active').addClass('hidden');
                }
                else {
                    $(item).removeClass('active').removeClass('hidden');
                }
            });
            $('.nav-element[data-tab-id=\'' + _main_1.txGs1Base.academyEventPanels.currentActiveTab + '\']').removeClass('hidden').addClass('active');
        }
        else {
            if (_main_1.txGs1Base.academyEventPanels.currentActiveTab < _main_1.txGs1Base.academyEventPanels.numAvailableTabs) {
                _main_1.txGs1Base.academyEventPanels.currentActiveTab = _main_1.txGs1Base.academyEventPanels.currentActiveTab + 1;
                $.each($('.nav-element'), function (index, item) {
                    if ($(item).data('tabId') !== _main_1.txGs1Base.academyEventPanels.currentActiveTab && $(item).data('tabId') !== (_main_1.txGs1Base.academyEventPanels.currentActiveTab - 1) && $(item).data('tabId') !== (_main_1.txGs1Base.academyEventPanels.currentActiveTab + 1)) {
                        if (_main_1.txGs1Base.academyEventPanels.currentActiveTab === _main_1.txGs1Base.academyEventPanels.numAvailableTabs && $(item).data('tabId') === (_main_1.txGs1Base.academyEventPanels.numAvailableTabs - _main_1.txGs1Base.academyEventPanels.numVisibleTabsMax + 1)) {
                            $(item).removeClass('active');
                        }
                        else {
                            $(item).removeClass('active').addClass('hidden');
                        }
                    }
                    else {
                        $(item).removeClass('active').removeClass('hidden');
                    }
                });
                $('.nav-element[data-tab-id=\'' + _main_1.txGs1Base.academyEventPanels.currentActiveTab + '\']').removeClass('hidden').addClass('active');
            }
        }
        // Finally tell the UI what tab should be marked a s selected
        this.selectTab($('.nav-element[data-tab-id=\'' + _main_1.txGs1Base.academyEventPanels.currentActiveTab + '\']'));
    }
};
exports.default = {};
